// src/screens/RegistroScreen.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { IoEye, IoEyeOff } from 'react-icons/io5';

function RegistroScreen() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const initialEmail = searchParams.get('email') || '';
  const urlParamsCodigo = searchParams.get('codigo') || '';
  const urlParamsInvita = searchParams.get('invita') || '';

  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [codigoActivacion, setCodigoActivacion] = useState(urlParamsCodigo);
  const [cuentaPadreId, setCuentaPadreId] = useState(urlParamsInvita);
  const [isStaffDetectado, setIsStaffDetectado] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, loginWithGoogle, loginWithFacebook, loginWithApple, completarRegistroSocial } = useAuth();

  // Efecto para detectar si el email es staff
  useEffect(() => {
    const checkStaff = async () => {
      if (!email || !email.includes('@')) {
        setIsStaffDetectado(false);
        return;
      }
      
      try {
        const { db } = await import('../firebaseConfig');
        const { doc, getDoc } = await import('firebase/firestore');
        const preConfigRef = doc(db, "usuarios_preconfigurados", email.toLowerCase().trim());
        const preConfigSnap = await getDoc(preConfigRef);
        
        if (preConfigSnap.exists()) {
          setIsStaffDetectado(true);
          const data = preConfigSnap.data();
          if (data.nombre) setNombre(data.nombre);
        } else {
          setIsStaffDetectado(false);
        }
      } catch (err) {
        console.error("Error detectando staff:", err);
      }
    };

    const timeoutId = setTimeout(checkStaff, 500);
    return () => clearTimeout(timeoutId);
  }, [email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    try {
      await register(email, password, nombre, codigoActivacion, cuentaPadreId);
    } catch (err) {
      if (err.message.includes("activación inválido")) {
        setError("El código de activación es incorrecto.");
      } else if (err.code === 'auth/email-already-in-use') {
        setError("Este email ya está en uso.");
      } else {
        setError(err.message || 'Error al crear la cuenta.');
      }
      console.error(err);
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="form-container" style={{maxWidth: '450px'}}>
      <h1 className="form-header">{cuentaPadreId ? 'Invitación a Inquilino' : 'Crear Cuenta'}</h1>
      
      {error && <p className="form-mensaje error">{error}</p>}
      
      <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
        <div className="form-group">
          <label className="form-label">Nombre Completo</label>
          <input 
            type="text" 
            className="form-input" 
            value={nombre} 
            onChange={(e) => setNombre(e.target.value)} 
            required 
            readOnly={isStaffDetectado}
            style={isStaffDetectado ? { backgroundColor: '#f1f5f9', cursor: 'not-allowed' } : {}}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input 
            type="email" 
            className="form-input" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
        </div>
        <div className="form-group">
          <label className="form-label">Contraseña (mín. 6 caracteres)</label>
          <div className="password-input-container">
            <input 
              type={showPassword ? 'text' : 'password'}
              className="form-input" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
            <button 
              type="button" 
              className="password-toggle-button"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <IoEyeOff /> : <IoEye />}
            </button>
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Confirmar Contraseña</label>
          <div className="password-input-container">
            <input 
              type={showPassword ? 'text' : 'password'}
              className="form-input" 
              value={confirmPassword} 
              onChange={(e) => setConfirmPassword(e.target.value)} 
              required 
            />
            <button 
              type="button" 
              className="password-toggle-button"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <IoEyeOff /> : <IoEye />}
            </button>
          </div>
        </div>

        {isStaffDetectado ? (
          <div className="form-group" style={{ background: '#f0fdf4', padding: '12px', borderRadius: '8px', border: '1px solid #bbf7d0', textAlign: 'center' }}>
            <p style={{ color: '#166534', margin: 0, fontSize: '0.9rem', fontWeight: 'bold' }}>
              ✨ Email corporativo detectado.
            </p>
            <p style={{ color: '#166534', margin: 0, fontSize: '0.8rem' }}>
              No se requiere código de activación.
            </p>
          </div>
        ) : (
          <div className="form-group">
            <label className="form-label">Código de Activación</label>
            <input 
              type="text" 
              className="form-input" 
              placeholder="El código que te dio tu administrador"
              value={codigoActivacion} 
              onChange={(e) => setCodigoActivacion(e.target.value)} 
              required
              readOnly={!!urlParamsCodigo}
              style={urlParamsCodigo ? { backgroundColor: '#f1f5f9', cursor: 'not-allowed' } : {}}
            />
          </div>
        )}

        <button type="submit" className="form-button btn-kondo" disabled={loading}>
          {loading ? 'Creando...' : 'Crear Cuenta'}
        </button>
      </form>
      
      <p style={{textAlign: 'center', marginTop: '20px'}}>
        ¿Ya tienes una cuenta? <Link to="/login" style={{ color: '#6A55DC', fontWeight: 'bold', textDecoration: 'none' }}>Inicia sesión</Link>
      </p>
    </div>
  );
}

export default RegistroScreen;